import ModalContext from 'components/Context/ModalContext'
import DataContainer from 'components/DataContainer/DataContainer'
import MediaQuery from 'components/MediaQuery/MediaQuery'
import gql from 'graphql-tag'
import React from 'react'
import YourAccount from './YourAccount'

const queries = [
  {
    query: gql`
      {
        me {
          _id
          name
          email
          twitter
          skype
          safeMarket
          parent
          group {
            _id
            yearGroup
            name
            description
            headerArtwork {
              url
            }
            battleLockedUntil
          }
        }
      }
    `,
    props: ({ data }) => {
      if (data.loading || data.error) {
        return { loading: data.loading, error: data.error }
      }

      const me = data.me
      const group = data.me.group

      return {
        isParent: me.parent,
        teacherDetails: {
          _id: me._id,
          name: me.name,
          email: me.email,
          twitter: me.twitter,
          skype: me.skype,
          safeMarket: me.safeMarket
        },
        classDetails: {
          _id: group._id,
          yearGroup: group.yearGroup,
          name: group.name,
          description: group.description,
          headerArtwork: group.headerArtwork && group.headerArtwork.url,
          battleLockedUntil: group.battleLockedUntil
        }
      }
    },
    options: {
      fetchPolicy: 'network-only'
    }
  }
]

const mutations = [
  {
    mutation: gql`
      mutation updateMe($user: UserInput, $userPassword: String) {
        updateMe(user: $user, userPassword: $userPassword) {
          _id
        }
      }
    `,
    props: ({ mutate }) => ({
      updateTeacherDetails: async (details, userPassword) => {
        await mutate({
          variables: {
            user: {
              ...details
            },
            userPassword
          }
        })
      }
    })
  },
  {
    mutation: gql`
      mutation updateGroup($group: UpdateGroupInput) {
        updateGroup(group: $group) {
          _id
        }
      }
    `,
    props: ({ mutate }) => ({
      updateClassDetails: async details => {
        await mutate({
          variables: {
            group: {
              ...details,
              yearGroup: parseInt(details.yearGroup)
            }
          }
        })
      }
    })
  }
]

const YourAccountContainer = props => (
  <ModalContext.Consumer>
    {modal => (
      <MediaQuery>
        <YourAccount {...props} modal={modal} />
      </MediaQuery>
    )}
  </ModalContext.Consumer>
)

export default props => (
  <DataContainer queries={queries} mutations={mutations}>
    <YourAccountContainer {...props} />
  </DataContainer>
)
